import { useSwapContext } from "@src/contexts";
import { Fees } from "@src/interfaces";
import { calculateFees } from "@src/utils";
import { useMemo } from "react";

const useGasFees = () => {
  const { route, shift4Fees, cashToken } = useSwapContext();
  const gasFees: Fees = useMemo(() => {
    if (!route) {
      return {
        platformFee: "0",
        networkFee: "0",
        onrampFee: "0",
      };
    }

    const { platformFee, networkFee, onrampFee } = calculateFees({
      route,
      cashToken,
      shift4Fees,
    });

    return {
      platformFee: platformFee,
      networkFee: networkFee,
      onrampFee: onrampFee,
    };
  }, [route, shift4Fees, cashToken]);
  return { gasFees };
};

export default useGasFees;
